import moment from 'moment';
import reportDao from '../../../../dao/reportDao';
import _isUndefined from 'lodash/isUndefined';
import {exampleData} from './components/exampleData';
import {eyewearExampleData} from './components/eyewearExampleData';
import accountDao from '../../../../dao/accountDao';

const LOAD = 'pages/webmodule/reports/userengagement/LOAD';
const NOT_LOAD = 'pages/webmodule/reports/userengagement/NOT_LOAD';
const LOAD_SUCCESS = 'pages/webmodule/reports/userengagement/LOAD_SUCCESS';
const CHANGE_DATE_RANGE =
  'pages/webmodule/reports/userengagement/CHANGE_DATE_RANGE';
const CHANGE_TIME_PERIOD =
  'pages/webmodule/reports/userengagement/CHANGE_TIME_PERIOD';
const SET_REPORT_VIEWED =
  'pages/webmodule/reports/userengagement/SET_REPORT_VIEWED';
const CHANGE_QUERY_MODE =
  'pages/webmodule/reports/userengagement/CHANGE_QUERY_MODE';
const LOAD_EXAMPLE = 'pages/webmodule/reports/userengagement/LOAD_EXAMPLE';

const initialState = {
  try: {data: {}, loaded: false, loading: false},
  save: {data: {}, loaded: false, loading: false},
  since: moment().subtract(6, 'month'),
  until: moment(),
  timePeriod: 'week',
  queryMode: 'all',
  isExampleData: false,
  reportViewed: false,
};
export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case LOAD:
      const newState1 = {...state};
      newState1[action.dataType].loading = true;
      newState1.dataType = action.dataType;
      newState1.isExampleData = false;
      return newState1;
    case NOT_LOAD:
      return {
        ...state,
        dataType: action.dataType,
      };
    case LOAD_SUCCESS:
      const newState2 = {...state};
      newState2[action.dataType].loaded = true;
      newState2[action.dataType].data = action.result;
      return newState2;
    case CHANGE_DATE_RANGE:
      return {
        ...state,
        try: {data: {}, loaded: false, loading: false},
        save: {data: {}, loaded: false, loading: false},
        since: action.since,
        until: action.until,
      };
    case CHANGE_TIME_PERIOD:
      return {
        ...state,
        try: {data: {}, loaded: false, loading: false},
        save: {data: {}, loaded: false, loading: false},
        timePeriod: action.timePeriod,
      };
    case CHANGE_QUERY_MODE:
      return {
        ...state,
        try: {data: {}, loaded: false, loading: false},
        save: {data: {}, loaded: false, loading: false},
        queryMode: action.queryMode,
      };
    case SET_REPORT_VIEWED:
      return {
        ...state,
        reportViewed: action.reportViewed,
      };
    case LOAD_EXAMPLE:
      const newState3 = {...state};
      const data =
        action.accountSummary.customer.functionType === 'EYEWEAR'
          ? eyewearExampleData()
          : exampleData();
      newState3.try.data = data['try' + action.queryMode].response;
      newState3.save.data = data['save' + action.queryMode].response;
      newState3.since = moment(
        data[action.dataType + action.queryMode].request.begin
      );
      newState3.until = moment(
        data[action.dataType + action.queryMode].request.end
      );
      newState3.timePeriod =
        data[action.dataType + action.queryMode].request.granularity;
      newState3.isExampleData = true;
      return newState3;
    default:
      return state;
  }
}

function load(dataType) {
  return {
    type: LOAD,
    dataType,
  };
}

function loadAsync(dataType) {
  return (dispatch, getState) => {
    dispatch(load(dataType));

    const params = {
      reportType: dataType.toUpperCase(),
      begin: getState().pages.webmodule.reports.userengagement.since.format(
        'YYYY-MM-DD'
      ),
      end: getState().pages.webmodule.reports.userengagement.until.format(
        'YYYY-MM-DD'
      ),
      granularity: getState().pages.webmodule.reports.userengagement.timePeriod,
      reportMode: getState().pages.webmodule.reports.userengagement.queryMode.toUpperCase(),
    };
    accountDao.queryEngagement().then(r => {
      dispatch(setReportViewed(r.reportViewed));
    });
    reportDao.listReport(params).then(json => {
      dispatch(loadSuccess(dataType, json));
      dispatch(
        loadExampleIfNeeded(
          dataType,
          getState().pages.webmodule.reports.userengagement.queryMode
        )
      );
    });
  };
}

function loadExample(dataType, queryMode, accountSummary) {
  return {
    type: LOAD_EXAMPLE,
    dataType,
    queryMode,
    accountSummary,
  };
}

function loadExampleIfNeeded(dataType, queryMode) {
  return (dispatch, getState) => {
    const accountSummary = getState().components.auth.accountSummary;
    const tryouts = getState().pages.webmodule.reports.userengagement.try;
    const save = getState().pages.webmodule.reports.userengagement.save;
    const isReportViewed = getState().pages.webmodule.reports.userengagement
      .reportViewed;
    const params = new URLSearchParams(getState().router.location.search);
    const page = params.get('page') || 'try';
    let shouldLoadExample =
      !isReportViewed &&
      (tryouts.loaded &&
        (_isUndefined(tryouts.data.valid) || !tryouts.data.valid.length));
    if (page === 'save')
      shouldLoadExample =
        !isReportViewed &&
        (shouldLoadExample ||
          (save.loaded &&
            (_isUndefined(save.data.valid) || !save.data.valid.length)));
    if (shouldLoadExample) {
      dispatch(loadExample(dataType, queryMode, accountSummary));
    }
  };
}

function notLoadAsync(dataType) {
  return {
    type: NOT_LOAD,
    dataType,
  };
}

function loadSuccess(dataType, result) {
  return {
    type: LOAD_SUCCESS,
    dataType,
    result,
  };
}

function shouldLoad(state, dataType) {
  const s = state.pages.webmodule.reports.userengagement[dataType];
  return !(s.loaded || s.loading);
}

export function loadIfNeeded(dataType) {
  return (dispatch, getState) => {
    if (shouldLoad(getState(), dataType)) {
      dispatch(load(dataType));
      return dispatch(loadAsync(dataType));
    } else {
      return dispatch(notLoadAsync(dataType));
    }
  };
}

export function changeDateRange(since, until) {
  return {
    type: CHANGE_DATE_RANGE,
    since,
    until,
  };
}

export function changeTimePeriod(timePeriod) {
  return {
    type: CHANGE_TIME_PERIOD,
    timePeriod,
  };
}

export function changeQueryMode(queryMode) {
  return {
    type: CHANGE_QUERY_MODE,
    queryMode,
  };
}

export function setReportViewed(reportViewed) {
  return {
    type: SET_REPORT_VIEWED,
    reportViewed,
  };
}
